// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_XdY","cls2":"CreateSocialItemModal-cls2_PUl CreateSocialItemModal-cls1_XdY"};